function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/_createClass(function _default() {
  var _this = this;

  _classCallCheck(this, _default);

  _defineProperty(this, "setInitialTouchState", function () {
    _this.touchStart = 0;
    _this.touchDist = 0;
  });

  _defineProperty(this, "resetTouchState", function () {
    _this.setInitialTouchState();
  });

  _defineProperty(this, "handleTouchStart", function (e) {
    var touchobj = e.changedTouches[0]; // reference first touch point (ie: first finger)
    // const startx = parseInt(touchobj.clientX); // relative to left edge

    var starty = parseInt(touchobj.clientY); // relative to top edge

    _this.touchStart = starty;
  });

  _defineProperty(this, "handleTouchMove", function (e) {
    e.preventDefault();
    var touchStart = _this.touchStart;
    var touchobj = e.changedTouches[0]; // reference first touch point for this event

    var touchDist = parseInt(touchobj.clientY) - touchStart;
    _this.touchDist = touchDist;
  });

  _defineProperty(this, "handleTouchEnd", function () {
    if (_this.touchDist < -10) {
      _this.prevMonthBtn.click();
    } else if (_this.touchDist > 10) {
      _this.nextMonthBtn.click();
    }

    _this.resetTouchState();
  });

  _defineProperty(this, "getCalElements", function () {
    var openDatepicker = document.querySelector('div.DayPicker_transitionContainer');
    var nextMonthBtn = document.querySelector('.DayPickerNavigation_button:nth-child(1)');
    var prevMonthBtn = document.querySelector('.DayPickerNavigation_button:nth-child(2)');
    if (!openDatepicker) return {};

    if (!nextMonthBtn || !prevMonthBtn) {
      return {};
    }

    return {
      openDatepicker: openDatepicker,
      nextMonthBtn: nextMonthBtn,
      prevMonthBtn: prevMonthBtn
    };
  });

  _defineProperty(this, "setCalElements", function (_ref) {
    var openDatepicker = _ref.openDatepicker,
        nextMonthBtn = _ref.nextMonthBtn,
        prevMonthBtn = _ref.prevMonthBtn;
    _this.openDatepicker = openDatepicker;
    _this.nextMonthBtn = nextMonthBtn;
    _this.prevMonthBtn = prevMonthBtn;
  });

  _defineProperty(this, "setTouchListeners", function () {
    var _this$getCalElements = _this.getCalElements(),
        openDatepicker = _this$getCalElements.openDatepicker,
        nextMonthBtn = _this$getCalElements.nextMonthBtn,
        prevMonthBtn = _this$getCalElements.prevMonthBtn;

    if (!openDatepicker) return false;

    _this.setCalElements({
      openDatepicker: openDatepicker,
      nextMonthBtn: nextMonthBtn,
      prevMonthBtn: prevMonthBtn
    });

    _this.openDatepicker.addEventListener('touchstart', _this.handleTouchStart, false);

    _this.openDatepicker.addEventListener('touchmove', _this.handleTouchMove, false);

    _this.openDatepicker.addEventListener('touchend', _this.handleTouchEnd, false);

    return true;
  });

  _defineProperty(this, "removeTouchListeners", function () {
    if (!_this.openDatepicker) return false;

    _this.openDatepicker.removeEventListener('touchstart', _this.handleTouchStart);

    _this.openDatepicker.removeEventListener('touchmove', _this.handleTouchMove);

    _this.openDatepicker.removeEventListener('touchend', _this.handleTouchEnd);

    return true;
  });

  this.setInitialTouchState();
});

export { _default as default };